module.exports = __webpack_public_path__ + "img/parceiro6.2fda2069.png";